import React, { useState } from "react";
import { login, register } from "./api";
import "./Login.css"; // On va créer ce fichier juste après

function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [mot_de_passe, setMotDePasse] = useState("");
  const [error, setError] = useState("");
  const [showRegister, setShowRegister] = useState(false);
  const [registerData, setRegisterData] = useState({
    nom: "",
    email: "",
    mot_de_passe: "",
    confirmPassword: ""
  });
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const data = await login(email, mot_de_passe);
    if (data.token) {
      localStorage.setItem("token", data.token);
      onLogin(data.user);
    } else {
      setError(data.message || "Login échoué");
    }
  };

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    
    // Validation
    if (registerData.mot_de_passe !== registerData.confirmPassword) {
      setError("Les mots de passe ne correspondent pas");
      return;
    }
    
    if (registerData.mot_de_passe.length < 6) {
      setError("Le mot de passe doit contenir au moins 6 caractères");
      return;
    }
    
    try {
      const data = await register(registerData.nom, registerData.email, registerData.mot_de_passe);
      if (data.message) {
        setMessage(data.message);
        setRegisterData({ nom: "", email: "", mot_de_passe: "", confirmPassword: "" });
      } else if (data.error) {
        setError(data.error);
      }
    } catch (err) {
      setError("Erreur lors de l'inscription");
    }
  };

  const handleRegisterChange = (field, value) => {
    setRegisterData(prev => ({ ...prev, [field]: value }));
  };

  if (showRegister) {
    return (
      <div className="login-container">
        <form className="login-form" onSubmit={handleRegisterSubmit}>
          <h2>Inscription</h2>
          {error && <div className="login-error">{error}</div>}
          {message && <div className="login-success">{message}</div>}
          
          <input
            value={registerData.nom}
            onChange={e => handleRegisterChange('nom', e.target.value)}
            placeholder="Nom complet"
            type="text"
            required
          />
          
          <input
            value={registerData.email}
            onChange={e => handleRegisterChange('email', e.target.value)}
            placeholder="Email"
            type="email"
            required
          />
          
          <input
            value={registerData.mot_de_passe}
            onChange={e => handleRegisterChange('mot_de_passe', e.target.value)}
            placeholder="Mot de passe"
            type="password"
            required
          />
          
          <input
            value={registerData.confirmPassword}
            onChange={e => handleRegisterChange('confirmPassword', e.target.value)}
            placeholder="Confirmer le mot de passe"
            type="password"
            required
          />
          
          <button type="submit">S'inscrire</button>
          
          <button 
            type="button" 
            className="switch-form-btn"
            onClick={() => {
              setShowRegister(false);
              setError("");
              setMessage("");
            }}
          >
            Déjà un compte ? Se connecter
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Connexion</h2>
        {error && <div className="login-error">{error}</div>}
        {message && <div className="login-success">{message}</div>}
        
        <input
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="Email"
          type="email"
          required
        />
        
        <input
          value={mot_de_passe}
          type="password"
          onChange={e => setMotDePasse(e.target.value)}
          placeholder="Mot de passe"
          required
        />
        
        <button type="submit">Se connecter</button>
        
        <button 
          type="button" 
          className="switch-form-btn"
          onClick={() => {
            setShowRegister(true);
            setError("");
            setMessage("");
          }}
        >
          Pas de compte ? S'inscrire
        </button>
      </form>
    </div>
  );
}

export default Login;
